<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="商品ID" prop="productId">
        <a-input v-model="form.productId" placeholder="请输入商品ID" />
      </a-form-model-item>
      <a-form-model-item label="积分数量" prop="credits">
        <a-input-number :min="1" v-model="form.credits" placeholder="请输入积分数量" />
      </a-form-model-item>
      <a-form-model-item label="赠送积分数量" prop="giveCredits">
        <a-input-number :min="0" v-model="form.giveCredits" placeholder="请输入赠送积分数量" />
      </a-form-model-item>
      <a-form-model-item label="商品类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">常驻</a-radio>
          <a-radio :value="2">首次购买</a-radio>
          <a-radio :value="3">特别优惠</a-radio>
          <a-radio :value="4">会员专享</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="价格" prop="price">
        <a-input-number :min="0" :step="0.01" v-model="form.price" placeholder="请输入价格" style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item label="划线价" prop="originalPrice">
        <a-input-number :min="0" :step="0.01" v-model="form.originalPrice" placeholder="请输入划线价" style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item label="倒计时(秒)" prop="countdown">
        <a-input-number :min="0" v-model="form.countdown" placeholder="请输入倒计时时长(秒)" />
      </a-form-model-item>

      <a-form-model-item label="是否突出展示" prop="isBig">
        <a-switch checked-children="是" un-checked-children="否" :checked="form.isBig === 1"
          @change="val => form.isBig = val ? 1 : 0" />
      </a-form-model-item>


      <a-divider>角标文案（多语言）</a-divider>
      <a-form-model-item label="中文角标" prop="remarkZh">
        <a-input v-model="form.remarkZh" placeholder="请输入中文角标文案" />
      </a-form-model-item>
      <a-form-model-item label="英文角标" prop="remarkEn">
        <a-input v-model="form.remarkEn" placeholder="请输入英文角标文案" />
      </a-form-model-item>
      <a-form-model-item label="日文角标" prop="remarkJa">
        <a-input v-model="form.remarkJa" placeholder="请输入日文角标文案" />
      </a-form-model-item>
      <a-form-model-item label="印尼角标" prop="remarkId">
        <a-input v-model="form.remarkId" placeholder="请输入印尼角标文案" />
      </a-form-model-item>
      <a-form-model-item label="葡语角标" prop="remarkPt">
        <a-input v-model="form.remarkPt" placeholder="请输入葡语角标文案" />
      </a-form-model-item>
      <a-form-model-item label="西语角标" prop="remarkEs">
        <a-input v-model="form.remarkEs" placeholder="请输入西语角标文案" />
      </a-form-model-item>

      <a-divider>标题（多语言）</a-divider>
      <a-form-model-item label="中文标题" prop="titleZh">
        <a-input v-model="form.titleZh" placeholder="请输入中文标题" />
      </a-form-model-item>
      <a-form-model-item label="英文标题" prop="titleEn">
        <a-input v-model="form.titleEn" placeholder="请输入英文标题" />
      </a-form-model-item>
      <a-form-model-item label="日文标题" prop="titleJa">
        <a-input v-model="form.titleJa" placeholder="请输入日文标题" />
      </a-form-model-item>
      <a-form-model-item label="印尼标题" prop="titleId">
        <a-input v-model="form.titleId" placeholder="请输入印尼标题" />
      </a-form-model-item>
      <a-form-model-item label="葡语标题" prop="titlePt">
        <a-input v-model="form.titlePt" placeholder="请输入葡语标题" />
      </a-form-model-item>
      <a-form-model-item label="西语标题" prop="titleEs">
        <a-input v-model="form.titleEs" placeholder="请输入西语标题" />
      </a-form-model-item>

      <a-divider>副标题（多语言）</a-divider>
      <a-form-model-item label="中文副标题" prop="subTitleZh">
        <a-input v-model="form.subTitleZh" placeholder="请输入中文副标题" />
      </a-form-model-item>
      <a-form-model-item label="英文副标题" prop="subTitleEn">
        <a-input v-model="form.subTitleEn" placeholder="请输入英文副标题" />
      </a-form-model-item>
      <a-form-model-item label="日文副标题" prop="subTitleJa">
        <a-input v-model="form.subTitleJa" placeholder="请输入日文副标题" />
      </a-form-model-item>
      <a-form-model-item label="印尼副标题" prop="subTitleId">
        <a-input v-model="form.subTitleId" placeholder="请输入印尼副标题" />
      </a-form-model-item>
      <a-form-model-item label="葡语副标题" prop="subTitlePt">
        <a-input v-model="form.subTitlePt" placeholder="请输入葡语副标题" />
      </a-form-model-item>
      <a-form-model-item label="西语副标题" prop="subTitleEs">
        <a-input v-model="form.subTitleEs" placeholder="请输入西语副标题" />
      </a-form-model-item>

      <a-form-model-item label="排序" prop="sort">
        <a-input-number :min="0" v-model="form.sort" placeholder="请输入排序值(越小越靠前)" />
      </a-form-model-item>
      <a-form-model-item label="是否启用" prop="isOpen">
        <a-switch checked-children="启用" un-checked-children="关闭" :checked="form.isOpen === 1"
          @change="val => form.isOpen = val ? 1 : 0" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRechargeMenu, addRechargeMenu, updateRechargeMenu } from '@/api/rechargeMenu/rechargeMenu.js'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',

      // 表单参数
      form: {
        id: null,
        productId: null,
        credits: null,
        type: null,
        price: null,
        isBig: 0,
        giveCredits: 0,
        originalPrice: null,
        countdown: null,
        remarkZh: null,
        remarkEn: null,
        remarkJa: null,
        remarkId: null,
        remarkPt: null,
        remarkEs: null,
        titleZh: null,
        titleEn: null,
        titleJa: null,
        titleId: null,
        titlePt: null,
        titleEs: null,
        subTitleZh: null,
        subTitleEn: null,
        subTitleJa: null,
        subTitleId: null,
        subTitlePt: null,
        subTitleEs: null,
        sort: null,
        isOpen: null,
        createTime: null,
        updateTime: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        productId: [
          { required: true, message: '商品ID不能为空' }
        ],
        credits: [
          { required: true, message: '积分数量不能为空' }
        ],
        type: [
          { required: true, message: '商品类型不能为空' }
        ],
        price: [
          { required: true, message: '价格不能为空' }
        ],
        originalPrice: [
          { required: true, message: '原价不能为空' }
        ],
        titleZh: [
          { required: true, message: '中文标题不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created() {
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        productId: null,
        credits: null,
        type: null,
        price: null,
        isBig: 0,
        giveCredits: 0,
        originalPrice: null,
        countdown: null,
        remarkZh: null,
        remarkEn: null,
        remarkJa: null,
        remarkId: null,
        remarkPt: null,
        remarkEs: null,
        titleZh: null,
        titleEn: null,
        titleJa: null,
        titleId: null,
        titlePt: null,
        titleEs: null,
        subTitleZh: null,
        subTitleEn: null,
        subTitleJa: null,
        subTitleId: null,
        subTitlePt: null,
        subTitleEs: null,
        productId: null,
        createTime: null,
        updateTime: null,
        sort: null,
        isOpen: null
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRechargeMenu({ "id": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRechargeMenu(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRechargeMenu(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
